<template>
    <div class="pv">
        <!-- <ParkOverView /> -->

        <div class="menuButtons">
            <MenuButton  :icons="[require('../../assets/img/deviceList_S.png'),require('../../assets/img/deviceList_U.png'),]" title="设备列表" 
            @click="menu === 1 ? menu = -1 : menu = 1" @on="isShowDeviceList = !isShowDeviceList" @off="isShowDeviceList = !isShowDeviceList"
            :selected="menu === 1"/>

            <!-- <MenuButton  :icons="[require('../assets/img/monitorS.png'),require('../assets/img/monitor_U.png'),]" title="安防监控" 
            @click="menu === 2 ? menu = -1 : menu = 2" @on="showMonitorList(true)" @off="showMonitorList(false)"
            :selected="menu === 2"/>

            <MenuButton  :icons="[require('../assets/img/接线图1.png'),require('../assets/img/接线图2.png'),]" title="接线图" 
            @click="isShowDiagram = !isShowDiagram"  @on="Diagram()" @off="Diagram1"
            :selected="isShowDiagram"/>  -->
        </div>
        <!-- 发电功率 -->
        <GeneratedOutput />
        <!-- 发电量统计 -->
        <ElectricityStatistics :areaId="areaId"/>
        <!-- 日发电趋势 -->
        <PowerToday :areaId="areaId"/>
        <!-- 逆变器概况 -->
        <ConverterProfile :areaId="areaId"/>
        <!-- 环保效益 -->
        <PvEnvironmental :areaId="areaId"/>

        <!-- 设备列表 -->
        <DeviceList :areaId="areaId" v-show="isShowDeviceList"/>


        <iframe name="THREE" id="#iframe" frameborder="0" width="100%" height="100%" ref="iframeThree"
            :src="url + $store.getters.getThreeUrl(areaId)">
        </iframe>

        <!-- <iframe name="THREE" id="#iframe" frameborder="0" width="100%" height="100%" ref="iframeThree"
            src="">
        </iframe> -->
    </div>
</template>

<script>
const ParkOverView = () => import('../components/ParkOverView.vue')
const GeneratedOutput = () => import('./components/GeneratedOutput.vue')
const ElectricityStatistics = () => import('./components/ElectricityStatistics.vue')
const PowerToday = () => import('./components/PowerToday.vue')
const ConverterProfile = () => import('./components/ConverterProfile.vue')
const PvEnvironmental = () => import('./components/PvEnvironmental.vue')
const DeviceList = () => import('./components/DeviceList.vue')
const MenuButton = () => import("../../components/menuButton/menuButton.vue")


import { config } from '../../config'
export default {
    data(){
        return {
            url: config.threeUrl,
            areaId:'',
            menu:0,
            isShowDeviceList:false
        }
    },
    components:{
        ParkOverView,
        GeneratedOutput,
        ElectricityStatistics,
        PowerToday,
        ConverterProfile,
        PvEnvironmental,
        DeviceList,
        MenuButton

    },
    created(){
        this.areaId = this.$route.params.id
        this.$store.commit('set_siteId',this.areaId)
        console.log(this.areaId);
    },
    mounted(){
        this.iframeWin = this.$refs.iframeThree.contentWindow;
        this.$store.commit('set_page',0)
        // setTimeout(()=>{
        //     this.menu = 1
        // },100)
    }
}
</script>

<style lang="less" scoped>
    .pv{
        width: 100%;
        height: 100%;
        .menuButtons{
            width: 10vw;
            height: 7vh;
            position: fixed;
            top: 6.8vh;
            left: 22.5vw;
            display: flex;
            flex-direction: row;
        }
    }
</style>